const anchorContent = () => {
  function detectCurrentAnchorContent() {
    var scrollDistance = document.documentElement.scrollTop + 25

    $('.c-anchored-content').each(function () {
      var component = $(this)
      var sidebar = component.find('.c-anchored-content__sidebar-links')
      var sidebarHeight = sidebar.outerHeight()
      var sidebarwidth = component
        .find('.c-anchored-content__sidebar')
        .innerWidth()
      var componentTop = component.offset().top
      var componentHeight = component.outerHeight()
      var componentBottom = componentTop + componentHeight
      var componentLeft = component.offset().left

      if (scrollDistance < componentTop) {
        component.find('.js-anchor-labels').removeClass('is-active')
        component.find('.js-anchor-labels').first().addClass('is-active')
      } else if (scrollDistance > componentBottom) {
        component.find('.js-anchor-labels').removeClass('is-active')
        component.find('.js-anchor-labels').last().addClass('is-active')
      }

      if (
        scrollDistance > componentTop &&
        scrollDistance + sidebarHeight <= componentBottom
      ) {
        sidebar.css({
          position: 'fixed',
          width: sidebarwidth + 'px',
          top: '25px',
          bottom: 'auto',
        })
      } else if (scrollDistance + sidebarHeight > componentBottom) {
        sidebar.css({
          position: 'absolute',
          top: 'auto',
          bottom: '0',
        })
      } else {
        sidebar.css({
          position: 'absolute',
          top: '0',
          bottom: 'auto',
        })
      }

      component.find('.js-anchor-sections').each(function () {
        var section = $(this)
        var sectionTop = section.offset().top - 100
        var sectionHeight = section.outerHeight()
        var sectionBottom = sectionTop + sectionHeight

        if (scrollDistance > sectionTop && scrollDistance <= sectionBottom) {
          var targetAnchor = section.attr('id')
          component.find('.js-anchor-labels').removeClass('is-active')
          $('a[href="#' + targetAnchor + '"]').addClass('is-active')
        }
      })
    })
  }

  document.addEventListener('scroll', detectCurrentAnchorContent, {
    passive: true,
  })

  $(window).resize(function () {
    detectCurrentAnchorContent()
  })
}

export default anchorContent
